'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n  ', ';\n  resize: none;\n'], ['\n  ', ';\n  resize: none;\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = require('decisiv-ui-utils');

var _TextField = require('../TextField');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var styles = (0, _styledComponents.css)(_templateObject, _TextField.styles);

var modifierConfig = _extends({}, _TextField.modifierConfig, {
  resizable: function resizable() {
    return '\n    resize: vertical;\n  ';
  }
});

exports.default = (0, _decisivUiUtils.buildStyledComponent)('TextArea', _styledComponents2.default.textarea.attrs({ rows: 2 }), styles, { modifierConfig: modifierConfig, themePropTypes: _TextField.themePropTypes });


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/elements/TextArea/index.js
// module id = 1530
// module chunks = 2